import { css as u, LitElement as b, nothing as d, html as s } from "lit";
import { property as i, customElement as h } from "lit/decorators.js";
import { b as m } from "./styles-scZ6dVz-.js";
import { b as v, a as f } from "./events-CkEPl0SM.js";
import "./ark-button-DYI_xPdn.js";
import "./ark-icon-TW_tZfDu.js";
var y = Object.defineProperty, g = Object.getOwnPropertyDescriptor, r = (l, o, n, a) => {
  for (var e = a > 1 ? void 0 : a ? g(o, n) : o, p = l.length - 1, c; p >= 0; p--)
    (c = l[p]) && (e = (a ? c(o, n, e) : c(e)) || e);
  return a && e && y(o, n, e), e;
};
let t = class extends b {
  constructor() {
    super(...arguments), this.title = "", this.subtitle = "", this.showClose = !0, this.closeLabel = "Close";
  }
  handleClose() {
    v(this, f.CLOSE);
  }
  renderTitle() {
    return this.title ? s`<div class="title" id=${this.titleId ?? d}>${this.title}</div>` : s`<slot name="title"></slot>`;
  }
  renderSubtitle() {
    return this.subtitle ? s`<div class="subtitle">${this.subtitle}</div>` : s`<slot name="subtitle"></slot>`;
  }
  render() {
    const l = !!this.subtitle || this.querySelector('[slot="subtitle"]');
    return s`
      <div part="header" class="header">
        <div part="titles" class="titles">
          ${this.renderTitle()}
          ${l ? this.renderSubtitle() : d}
        </div>
        <div part="actions" class="actions">
          <slot name="actions"></slot>
          ${this.showClose ? s`
                <ark-button
                  class="close-button"
                  variant="ghost"
                  size="sm"
                  icon-only
                  label=${this.closeLabel}
                  @click=${this.handleClose}
                >
                  <ark-icon name="x" size="sm"></ark-icon>
                </ark-button>
              ` : d}
        </div>
      </div>
    `;
  }
};
t.styles = [
  m,
  u`
      :host {
        display: block;
      }

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--r5-space-3);
        padding: var(--r5-space-4);
        border-bottom: 1px solid var(--r5-border);
        background: var(--r5-surface);
      }

      .titles {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-1);
        min-width: 0;
      }

      .title {
        font-size: var(--r5-text-lg);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
      }

      .subtitle {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
      }

      .actions {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-1);
        flex-shrink: 0;
      }

      .close-button::part(button) {
        padding: var(--r5-space-1);
      }
    `
];
r([
  i({ type: String })
], t.prototype, "title", 2);
r([
  i({ type: String, attribute: "title-id" })
], t.prototype, "titleId", 2);
r([
  i({ type: String })
], t.prototype, "subtitle", 2);
r([
  i({ type: Boolean, attribute: "show-close" })
], t.prototype, "showClose", 2);
r([
  i({ type: String, attribute: "close-label" })
], t.prototype, "closeLabel", 2);
t = r([
  h("ark-modal-header")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-modal-header-rIoKAmAD.js.map
